/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ControlDecorator from 'shared/ui/components/form-components/ControlDecorator.vue';

const __vue_script__ = {
    componentName: 'TimeSlotPicker',
    components: {
        ControlDecorator
    },
    props: {
        value: {
            type: String,
            default: null
        },

        edit: {
            type: Boolean,
            default: false
        },

        event: {
            type: Object,
            default: () => ({})
        },

        label: {
            type: String,
            default: null
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isReadOnly: false,
            timeslots: [],
            totalParticipantCount: 0,
            duration: 15 * 60,
            loading: true,
            skipCreatedHook: false
        };
    },
    async created() {
        if (this.skipCreatedHook) return;
        await this.updateData();
    },
    methods: {
        /**
         * Recalculate data of the component based on the current model
         */
        async updateData() {
            this.loading = true;

            const participants = this.$attrs.model.participants || [];

            this.totalParticipantCount = participants.length;

            const tmpTimeslots = this.getTimeslots(participants);
            await this.addRoomAvailability(tmpTimeslots);
            this.sortTimeslots(tmpTimeslots);
            await this.blockRepresentativeBusySlots(tmpTimeslots);

            this.timeslots = tmpTimeslots;

            this.selectDefaultTimeslot();

            this.isReadOnly = !['awaiting', 'ready'].includes(this.$attrs.model.status);

            this.loading = false;
        },

        /**
         * Combine availability of all participants to get timeslots
         * @param participants Array of participants
         */
        getTimeslots(participants) {
            if (!participants?.length) {
                return [];
            }

            const availabilityMap = {};

            for (const p of participants) {
                if (!p.availability) {
                    continue;
                }
                for (const { start } of p.availability) {
                    if (!availabilityMap[start]) {
                        availabilityMap[start] = {
                            start,
                            startDate: this.$utils.time.fomatTimeWithTimezone(start, this.event.timezone, 'll'),
                            startTime: this.$utils.time.fomatTimeWithTimezone(start, this.event.timezone, 'LT'),
                            availableRooms: 0,
                            participantCount: 0,
                        };
                    }
                    availabilityMap[start].participantCount++;
                }
            }

            return Object.values(availabilityMap);
        },

        /**
         * Timeslot sorting:
         * 1. By participant count (descending order). More participants first
         * 2. If counts are the same, by start time (ascending order).
         *    Within same participant count earlier timeslots first.
         */
        sortTimeslots(timeslots) {
            return timeslots.sort(
                (a, b) => {
                    if (b.participantCount !== a.participantCount) {
                        return b.participantCount - a.participantCount;
                    }
                    return new Date(a.start).getTime() - new Date(b.start).getTime();
                });
        },

        /**
         * Select the default timeslot if no value is selected,
         * or the selected value is not valid anymore
         */
        selectDefaultTimeslot() {
            const valueAlreadySelected = !!this.value;
            const selectedValueIsValid = valueAlreadySelected && this.timeslots.some(t => t.start === this.value);

            if (!selectedValueIsValid) {
                // Pick 1st
                this.onTimeSlotSelected(this.timeslots?.length ? this.timeslots[0] : null);
            }
        },

        /**
         * Handle the timeslot selection
         * @param {Object} timeslot
         */
        onTimeSlotSelected(timeslot) {
            if (this.isReadOnly) {
                return;
            }

            this.$emit('input', timeslot?.start || null);
        },

        /**
        * Adding available room count for timeslots
        */
        async addRoomAvailability(timeslots) {
            return Promise.all(timeslots.map(async (timeslot) => {
                try {
                    timeslot.availableRooms = await this.getRoomOptions(timeslot);
                } catch (e) {
                    console.error('[TimeSlotPicker] Failed to get room options for timeslot', timeslot, e);
                }
                return timeslot;
            }));
        },

        /**
         * Rep/Organizer might be busy at certain times.
         *
         * @param {TimeSlot[]} timeslots We expect this array is going to be sorted!
        */
        async blockRepresentativeBusySlots(timeslots) {
            if (timeslots.length === 0) {
                return timeslots;
            }

            /** @type {{ blockedSlots: TimeSlot[] }} */
            const { blockedSlots } = await this.$services.meetings.getRepresentativeBlockedSlots(this.event._id, this.$attrs.model._id);
            const duration = Number.parseInt(this.$attrs.model.duration, 10) || 0;

            return this.$utils.time.markTimeslotsOverlapWithBlocked(timeslots, blockedSlots, duration);
        },

        /**
         * Room options for timeslot.
         */
        async getRoomOptions(timeslot) {
            const potentialMemberCount = this.$attrs.model.participants.filter(
                // Not answered or available for this timeslot
                (p) => !Array.isArray(p.availability) || p.availability.map(a => a.start).includes(timeslot.start)
            ).length + 1; // +1 is for organizer

            const { availableRooms } = await this.$services.appScripts.callAppScript(
                this.event._id, 'actions/check-location-availability',
                {
                    timestamp: this.$utils.time.dateToFormat(timeslot.start, 'X'),
                    duration: Number.parseInt(this.$attrs.model.duration, 10),
                    capacity: potentialMemberCount,
                }
            );
            return availableRooms.length ?? 0;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      attrs: {
        label: _vm.label,
        uid: "meeting-request-timeslots#" + _vm.$attrs.model._id,
        "hint-after-label": true,
        hint: _vm.$t("meetings.requests.timeslots.hint"),
      },
    },
    [
      !_vm.loading
        ? _c(
            "div",
            {
              staticClass: "meeting-request-timeslot-picker",
              class: { "read-only": _vm.isReadOnly },
            },
            [
              _vm.timeslots.length
                ? _c(
                    "div",
                    { staticClass: "timeslots" },
                    _vm._l(_vm.timeslots, function (timeslot) {
                      return _c(
                        "div",
                        {
                          key: timeslot.start,
                          staticClass: "timeslot",
                          class: {
                            selected: _vm.value === timeslot.start,
                            disabled: _vm.isReadOnly,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onTimeSlotSelected(timeslot)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "top-section" }, [
                            _c("div", { staticClass: "date" }, [
                              _vm._v(_vm._s(timeslot.startDate)),
                            ]),
                            _c("div", { staticClass: "time" }, [
                              _vm._v(_vm._s(timeslot.startTime)),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "participants",
                                class: {
                                  success:
                                    timeslot.participantCount ===
                                    _vm.totalParticipantCount,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "meetings.requests.timeslots.available"
                                    )
                                  ) +
                                    "\n" +
                                    _vm._s(" ")
                                ),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(timeslot.participantCount) +
                                      "/" +
                                      _vm._s(_vm.totalParticipantCount)
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "rooms" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$tc(
                                  "meetings.requests.timeslots.available-rooms",
                                  timeslot.availableRooms,
                                  [timeslot.availableRooms]
                                )
                              )
                            ),
                          ]),
                          !_vm.isReadOnly && timeslot.isRangeOverlap
                            ? _c("div", { staticClass: "note-section" }, [
                                _c("div", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "meetings.requests.timeslots.already-booked"
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "empty-state" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("meetings.requests.timeslots.empty"))
                      ),
                    ]),
                  ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/TimeslotPickerInMeetingRequests.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__